import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles.css';

import Footer from './components/Footer';
import BackgroundChecks from './pages/BackgroundChecks';
import Blog from './pages/Blog'; // This is the dynamic detail view
import Blogs from './pages/Blogs';
import Faq from './pages/Faq';
import NotFound from './pages/NotFound';
import Pricing from './pages/Pricing';
import { usePageTracking } from './hooks/UsePageTracking'; // or wherever you saved it

export default function App() {
    return (
        <Router>
            <PageTracker />
            <Routes>
                <Route path="/" element={<BackgroundChecks />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<Blog />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/pricing" element={<Pricing />} />
                {/* add a catch-all if needed */}
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </Router>
    );
}

function PageTracker() {
    usePageTracking();
    return null;
}